import React from 'react';
import { Channel, Window } from 'stream-chat-react';
import { ChannelContent } from './ChannelContent';
import { StatusAwareSendButton, WebAttachmentSelector } from './ChatInputComponents.web';
import type { UniverseStreamChannel } from '@/services/stream/types';

const backgroundImage = require("@/assets/images/channel-bg-web.png");

interface ChannelViewProps {
    channel: UniverseStreamChannel;
    isTablet?: boolean;
}

export function ChannelView({ channel, isTablet }: ChannelViewProps) {
    const imageUrl = typeof backgroundImage === 'string' ? backgroundImage : backgroundImage?.uri;

    return (
        <Channel channel={channel} AttachmentSelector={WebAttachmentSelector} SendButton={StatusAwareSendButton}>
            <Window>
                <div style={{
                    position: 'relative',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    backgroundImage: imageUrl ? `url(${imageUrl})` : undefined,
                    backgroundRepeat: 'repeat',
                    backgroundSize: 'auto',
                }}>
                    <style>
                        {`
                        .str-chat {
                            --str-chat__container-bg: transparent;
                            --str-chat__primary-color: #14a5c6;
                            height: 100%;
                        }
                        .str-chat .str-chat__attachment-selector .str-chat__attachment-selector__menu-button .str-chat__attachment-selector__menu-button__icon {
                            background-color: #14a5c6;
                        }
                        .str-chat .str-chat__message-input .str-chat__send-button:not(:disabled) {
                            color: #14a5c6;
                        }
                        .str-chat .str-chat__message-input .str-chat__send-button:not(:disabled) svg path {
                            fill: #14a5c6;
                        }
                        .str-chat .str-chat__message-input .str-chat__start-recording-audio-button {
                            color: #14a5c6;
                        }
                        .str-chat-channel,
                        .str-chat__container,
                        .str-chat__main-panel,
                        .str-chat__list,
                        .str-chat__main-panel-inner,
                        .str-chat__window {
                            background-color: transparent !important;
                            background: transparent !important;
                        }
                        .str-chat__empty-channel {
                            background-color: transparent !important;
                        }
                        /* A non-active chat renders a read-only composer. Stream's
                           stylesheet has no [readonly] rule, so the box would look
                           fully live while silently dropping every keystroke — mute
                           it and make the explanatory placeholder legible. */
                        .str-chat .str-chat__message-textarea[readonly] {
                            cursor: not-allowed;
                        }
                        .str-chat .str-chat__message-textarea[readonly]::placeholder {
                            color: #6B7280;
                            opacity: 1;
                        }
                        .str-chat .str-chat__message-textarea-container:has(.str-chat__message-textarea[readonly]) {
                            background: #F3F4F6;
                        }
                        `}
                    </style>
                    <ChannelContent isTablet={isTablet} />
                </div>
            </Window>
        </Channel>
    );
}
